module.exports = "/images/pin-digital.png?fe0adbc4a86163350eb62760350e795f";